import React, { useContext, useEffect, useState } from "react";
import classes from "./PopupModal.module.css";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { useNavigate } from "react-router-dom";

import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import { FreeMode, Pagination } from "swiper/modules";
import BookEdge from "../../../assets/BookEdge.png";

import img from "../../../assets/bookPlaceHolder.png";
import { toast } from "react-toastify";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import { useDispatch, useSelector } from "react-redux";
import {
  addTocart,
  addTocompare,
  addTofavorite,
  deletefavorite,
} from "../../redux/productSlice";
import data from "../../Data.json";
// import './MostPopular.css'
import { IoGitCompare } from "react-icons/io5";
import AuthContext from "../../Common/authContext";
import axios from "axios";
import nodata from "../../../assets/nobookfound.svg";
import { stripHtmlTags, truncateText } from "../TextUtils";


const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 1300,
  bgcolor: "#fff",
  boxShadow: 24,
  fontSize: "calc(0.7rem + 0.2vw)",
  borderRadius: "4em 0",
  overflow:'hidden',
};

const CartPopupModal = ({ open, handleClose, isselectedAddress }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.products.userInfo);
  const language = useSelector(
    (state) => state.products.selectedLanguage[0].Language
  );
  const [modalopen, setModalOpen] = React.useState(false);
  const handleaddOpen = () => setModalOpen(true);
  const handleaddClose = () => setModalOpen(false) & authCtx.setisPopupCartOpen(false);
  const authCtx = useContext(AuthContext);
  const currency = useSelector(
    (state) => state.products.selectedCurrency[0].currency
  );

  const compareData = useSelector((state) => state.products.compare);
  const favoriteData = useSelector((state) => state.products.favorites);
  const [articles, setArticles] = useState([]);

  
  useEffect(() => {
    fetchArticles();
  }, []);

  const fetchArticles = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_TESTING_API}/articles?ecom_type=${process.env.REACT_APP_ECOM_TYPE}&favorites`
      );
      // console.log(response.data.data)
      setArticles(response.data.data);
    } catch (error) {
      // console.error("Error fetching articles:", error);
      // toast.error(`${language === 'eng' ? "Failed to fetch articles." : "Échec de la recherche d'articles."}`);
    } 
  };

  const CompareHandler = (event, props) => {
    if (!compareData?.some((item) => item._comid === props.id)) {
      dispatch(
        addTocompare({
          _comid: props.id,
          comtitle: props.designation,
          comimage: props.articleimage[0]?.link,
          comprice: props.prixpublic,
          comquantity: 1,
          _qte_a_terme_calcule: props._qte_a_terme_calcule,
          _code_barre: props._code_barre,
          comdescription: props.descriptif,
          comDisponibilité: props.Disponibilité,
          comauthor: props.dc_auteur,
          comTraducteur: props.dc_traducteur,
          comIllustrateur: props.Illustrateur,
          comCollection: props.dc_collection,
          comEditeur: props.dc_isbn_editeur,
          comNbPages: props.nbpages,
          comDimensions: `${props.hauteur} x ${props.largeur} x ${props.epaisseur} `,
          comCouverture: props.Couverture,
          comdate: props.dc_parution,
          comPoids: props._poids_net,
          comstock:props.article_stock,
        })
      );
      event.stopPropagation();
    } else {
      toast.error(`${language === 'eng' ? `${props.name} is already added` : "le produit est déjà ajouté"}`, {
        position: "top-right",
        autoClose: 1500,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
        theme: "colored",
      });
      event.stopPropagation();
    }
  };
  const EnArticlesWithTruncatedtitle = articles.map((article) => ({
    ...article,
    designation: article?.designation
      ? article?.designation.substring(0, 20) +
        (article?.designation.length > 20 ? "..." : "")
      : "",
  }));

  useEffect(() => {
    setModalOpen(authCtx.isPopupCartOpen)
    // console.log('helooo')
  }, [authCtx.isPopupCartOpen]);


  return (
      <Modal
        open={modalopen}
        onClose={handleaddClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{ overflow: "hidden" }}
      >
        <Box sx={style}>
              <h1 className={classes.mainTitle}>{language === 'eng' ? "an item has been added to your cart" : "un article a bien été ajouté à votre panier"}</h1>
          <div className={classes.formmm} 
            style={{
              width: "100%",
              margin: "0 auto",
              alignItems: "center",
              textAlign: "center",
              justifyItems: "center",
              backgroundColor: "#fff",
              maxHeight: "85vh",
              overflowY: "scroll",
              paddingTop:'2em',
              paddingBottom:'2em',
            }}>
              <div className={classes.detailsContainer}>
                <div className={classes.imageContainer}>
                        <img src={`${authCtx.addedBookCart?.articleimage?.length > 0 ? authCtx.addedBookCart?.articleimage[0]?.link : img}`} alt="" className={classes.img} />
                </div>
                <div className={classes.details}>
                  <h2>{authCtx.addedBookCart?.designation}</h2>
                  {authCtx.addedBookCart?.dc_auteur && <p style={{margin:'0'}}>{language === "eng" ? "Author" : "Auteur"} : {authCtx.addedBookCart?.dc_auteur}</p>}
                  <p>{truncateText(stripHtmlTags(authCtx.addedBookCart?.descriptif), 5000)}</p>
                  <div className={classes.btnsContainer}>
                    <button style={{backgroundColor:'var(--accent-color)'}} onClick={()=>navigate(`/products`) & handleaddClose()}>{language === "eng" ? "Continue shopping" : "Poursuivre mes achats"} </button>
                    <button onClick={()=>navigate(`/cart`)& handleaddClose()}>{language === "eng" ? "Complete my order" : "Terminer ma commande"} </button>
                  </div>
                </div>
              </div>
            
      <div className={classes.bigContainer} id="home">
        <div className={classes.header}>
          <div className={classes.title}>
            <h1 onClick={()=>console.log(authCtx.addedBookCart)}>{language=== 'eng' ? "Discover our favorites" : "Découvrez nos coups de coeur"}</h1>
            <div className={classes.border} />
          </div>
        </div>{" "}
        {EnArticlesWithTruncatedtitle?.length === 0 ? (
          <div className={classes.nodata}>
            <div className={classes.nodata_img}>
              <img src={nodata} alt="" />
            </div>
            <h1>{language === 'eng' ? "No Products were found!" : "Aucun produit n'a été trouvé !"}</h1>
          </div>
        ) : (
          <div className={classes.swiper}>
            <Swiper
              // slidesPerView={3}
              spaceBetween={20}
              effect={"fade"}
              pagination={{
                clickable: true,
              }}
              modules={[Pagination]}
              style={{
                padding: "0 1em",
              }}
              breakpoints={{
                0: {
                  slidesPerView: 2,
                },
                651: {
                  slidesPerView: 4,
                },
                951: {
                  slidesPerView: 6,
                },
              }}
            >
              {EnArticlesWithTruncatedtitle?.sort((a,b) => b.bestseller_count - a.bestseller_count).filter(
                (props) => props.designation.trim() !== ""
              ).map((props) => (
                <SwiperSlide className={classes.swiperslide} key={props.id}>
                  <div
                    className={classes.card_container}
                    onClick={(event) => {
                      authCtx.setbookDetails(props);
                      event.stopPropagation();
                      navigate(`productdetails/${props.id}`);
                    }}
                  >
                    <div className={classes.card_img} style={{position:'relative',overflow:"hidden"}}>
                     {props._qte_a_terme_calcule < 1 && <div style={{cursor:'pointer'}} className={classes.out_of_stock}>
                        <p>{language === "eng" ? "OUT OF STOCK" : "EN RUPTURE"}</p>
                      </div>}
                      {props.articleimage[0] ? (
                        <img
                          src={`${props.articleimage[0]?.link}`}
                          alt={props.articleimage[0]?.type}
                          width="100%"
                          height="100%"
                          className={classes.img}
                        />
                      ) : (
                        <img
                          src={img}
                          className={classes.img}
                          alt=""
                          width="100%"
                          height="100%"
                        />
                      )}
                      <img src={BookEdge} alt="" className={classes.bookEdge} />
                    </div>
                    <div className={classes.bookTitle}>
                      <p style={{ height: "3em" }}>{props.designation}</p>
                      <span style={{ display: "flex", flexDirection: "row",columnGap:'0.5em',justifyContent:'space-around' }}>
                        <p
                          style={{ textAlign: "start", padding: "2% 0 0 0%" }}
                        >
                          {currency === "eur"
                            ? `${
                                props.discount > 0
                                  ? (
                                      props._prix_public_ttc -
                                      props._prix_public_ttc * (props.discount / 100)
                                    ).toFixed(2)
                                  : Number(props._prix_public_ttc).toFixed(2)
                              } €`
                            : `${
                                props.discount > 0
                                  ? (
                                      (props._prix_public_ttc -
                                        props._prix_public_ttc *
                                          (props.discount / 100)) *
                                      authCtx.currencyRate
                                    ).toFixed(2)
                                  : (
                                      props._prix_public_ttc * authCtx.currencyRate
                                    ).toFixed(2)
                              } $`}{" "}
                        </p>
                        {props.discount > 0 && (
                          <p
                            style={{
                              color: "var(--primary-color)",
                              textDecoration: "line-through",
                              fontSize: "small",
                              margin:"auto 0"
                            }}
                          >
                            {currency === "eur"
                              ? ` ${Number(props._prix_public_ttc).toFixed(2)} €`
                              : ` ${(
                                  props._prix_public_ttc * authCtx.currencyRate
                                ).toFixed(2)} $`}
                          </p>
                        )}
                      </span>
                    </div>
                      <div className={classes.iconsContainer}>
                        {props._qte_a_terme_calcule > 0 &&<div style={{cursor:authCtx.isLoading ? "wait" : 'pointer'}}
                        
                          className={classes.favoriteIcon}
                          onClick={(event) => {
                            event.stopPropagation();
                            if (!authCtx.isLoading) {
                                if (props.article_variant_combinations && props.article_variant_combinations.length > 0) {
                                  authCtx.setaddtocartPopupOpen(true);
                                  authCtx.setaddtocartPopupId(props.id);
                                } else {
                                  authCtx.addToCart({props: props,});
                                }
                            }
                          }}
                        >
                          <ShoppingCartOutlinedIcon
                            style={{ height: "0.9em", marginTop: "-0.2em" }}
                          />
                        </div>}

                        <div className={classes.favoriteIcon}>
                          {favoriteData?.some(
                            (book) => book._favid === props.id
                          ) ? (
                            <FavoriteIcon
                              className={classes.fav}
                              style={{ height: "1em" }}
                              onClick={(event) => {
                                event.stopPropagation();
                                authCtx.deleteFavorite(props.id);
                              }}
                            />
                          ) : (
                            <FavoriteBorderIcon
                              className={classes.nonfav}
                              style={{ height: "1em" }}
                              onClick={(event) => {
                                event.stopPropagation();
                                authCtx.addToFavorite(props);
                              }}
                            />
                          )}
                        </div>
                      </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        )}
      </div>
          </div>
        </Box>
      </Modal>
  );
};
export default CartPopupModal;
